import React from "react";
import { Flame, Sparkles, Star, ArrowRight, Bot } from "lucide-react";
import { useRecommendations } from "../context/RecommendationsContext";

const META = [
  { label: "Número Fuerte", icon: Star, color: "from-blue-600 to-blue-800" },
  { label: "Número Caliente", icon: Flame, color: "from-orange-500 to-red-600" },
  { label: "Número Extra", icon: Sparkles, color: "from-emerald-500 to-emerald-700" },
];

export default function StrongNumbers() {
  const { data, loading } = useRecommendations();
  const list = (data?.strong_numbers || []).slice(0, 3);

  return (
    <section id="numeros-del-dia" className="py-16 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-50 text-[#0e4a7a] text-xs font-semibold mb-3 border border-blue-100">
            <Bot className="w-3.5 h-3.5" /> PROMETEO
          </div>
          <h2 className="np-title inline-block text-2xl sm:text-3xl font-extrabold text-[#0e4a7a]">
            Tres Números Fuertes para Hoy
          </h2>
          <p className="text-gray-600 max-w-3xl mx-auto mt-4 text-sm sm:text-base">
            Seleccionados por Prometeo tras analizar patrones recientes, frecuencia y comportamiento numérico de los últimos sorteos. Ideales para combinaciones, palés o tripletas.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {(loading && !list.length
            ? [{}, {}, {}]
            : list
          ).map((n, idx) => {
            const meta = META[idx] || META[0];
            const Icon = meta.icon;
            const value = n.value || "—";
            return (
              <div
                key={idx}
                className="np-card bg-white rounded-2xl p-6 border border-blue-100 shadow-md"
              >
                <div className={`relative h-44 rounded-xl bg-gradient-to-br ${meta.color} flex items-center justify-center overflow-hidden`}>
                  <div className="absolute inset-0 opacity-20" style={{backgroundImage: 'radial-gradient(circle at 20% 20%, white, transparent 40%), radial-gradient(circle at 80% 80%, white, transparent 40%)'}} />
                  <Icon className="absolute top-4 right-4 w-6 h-6 text-white/70" />
                  <span className="relative text-white font-extrabold text-5xl sm:text-6xl tracking-wider drop-shadow-lg" style={{fontFamily: 'Playfair Display, serif'}}>
                    {loading && !list.length ? <span className="opacity-50">————</span> : value}
                  </span>
                </div>
                <div className="mt-5 flex items-center justify-between">
                  <div>
                    <p className="text-xs uppercase tracking-wider text-gray-500">{n.label || meta.label}</p>
                    <p className="text-lg font-bold text-[#0e4a7a]">Número #{idx + 1}</p>
                  </div>
                  <button className="inline-flex items-center gap-1 text-sm font-semibold text-[#1d6cb1] hover:gap-2 transition-all">
                    Detalles <ArrowRight className="w-4 h-4" />
                  </button>
                </div>
              </div>
            );
          })}
        </div>

        {data?.analysis && (
          <div className="mt-8 max-w-3xl mx-auto bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-2xl p-5 flex gap-3">
            <div className="w-10 h-10 rounded-full bg-[#1d6cb1] text-white flex items-center justify-center flex-shrink-0">
              <Bot className="w-5 h-5" />
            </div>
            <div>
              <p className="text-xs font-bold uppercase tracking-wider text-[#1d6cb1] mb-1">Análisis de Prometeo</p>
              <p className="text-sm text-gray-700 leading-relaxed">{data.analysis}</p>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
